import React from 'react';
import PropTypes from 'prop-types';

import {
    SiteStructure,
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eb/site-structure';

import { gettext } from '@eb/i18n-ebspa';

// Deal with the messed up Varnish urls (/esi_cahe/?...) which break the signin link
const fixLoginUrl = (loginUrl) => {
    const splitUrl = loginUrl.split('/');
    const urlBeginning = splitUrl.slice(0, -1);

    return urlBeginning.concat('?referrer=%2F').join('/');
};

export default class BasePage extends React.Component {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
        isMobile: PropTypes.bool,
        handleSearch: PropTypes.func,
        shouldStopRenderEarly: PropTypes.bool,
        isHomePage: PropTypes.bool,
        isSearchPage: PropTypes.bool,
        children: PropTypes.node,
        structureHeader: PropTypes.func,
    };

    componentDidMount() {
        // Accessibility improvement on a component with (still) unknown location
        const userMenuItem = document.querySelector(
            '.consumer-header__user-menu.consumer-header__menu',
        );

        if (userMenuItem) {
            const userMenuLink = userMenuItem.querySelector('a');

            if (userMenuLink) {
                userMenuLink.setAttribute('aria-label', gettext('User menu'));
            }
        }
    }

    render() {
        const {
            env,
            request,
            user,
            footerLinks,
            isMobile,
            handleSearch,
            isHomePage,
            isSearchPage,
            featureFlags,
            seasonalContent,
            structureHeader,
        } = this.props;

        const Header = structureHeader;

        return (
            <SiteStructure
                env={env}
                request={request}
                user={user}
                fullScreenMain={true}
                globalHeader={
                    <Header
                        env={{
                            ...env,
                            loginUrl: fixLoginUrl(env.loginUrl),
                        }}
                        request={request}
                        user={user}
                        handleSearch={handleSearch}
                        isMobile={isMobile}
                        isHomePage={isHomePage}
                        isSearchPage={isSearchPage}
                        featureFlags={featureFlags}
                        seasonalContent={seasonalContent}
                    />
                }
                isUserAuthenticated={user.isAuthenticated}
                showMarketingLinks={!user.isAuthenticated}
                footerLinks={footerLinks}
            >
                {this.props.children}
            </SiteStructure>
        );
    }
}
